export default {"src":"/_next/static/media/toothCrack_64.e21069c3.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};